import { AnimationBaseController } from "../../modules/@denishussar/html5-game-engine";


/**
 * 
 * @param modal controller
 * @param width display width
 * @param height display height
 * @param scale display scale
 * @param _width controller width
 * @param _height controller height
 */
export const scaleModal = (modal: AnimationBaseController, width: number, height: number, scale: number, _width: number, _height: number) => {
    let sizeW = width / scale;
    let sizeH = height / scale;



    const containerScale = Math.min(sizeW / _width, sizeH / _height);
    modal.scaleX = containerScale;
    modal.scaleY = containerScale;
};